import styled from "styled-components";

export default styled.div`
  display: table;
  margin: 2em auto;
  padding-left: 2.5em;
  position: relative;

  > p {
    margin: 0px;

    @media print {
      line-height: 2.8;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/tekst/Text.js